export type ActivityDetailTabId =
  "general" | "availability" | "configuration" | "preview" | "staff";

const ACTIVITY_DETAIL_TAB_IDS: readonly ActivityDetailTabId[] = [
  "general",
  "availability",
  "configuration",
  "preview",
  "staff",
];

/** Parses the `?tab=` search param; unknown or unavailable tabs fall back to general. */
export function parseActivityDetailTab(
  raw: string | null,
  staffTabAvailable: boolean,
): ActivityDetailTabId {
  const tab = ACTIVITY_DETAIL_TAB_IDS.find((id) => id === raw) ?? "general";
  return tab === "staff" && !staffTabAvailable ? "general" : tab;
}
